// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextBlockSlice_wrapper__wfJSL"};